import { StyledTableCell } from '@/components/boxes/BoxTools.tsx';
import {
  ErrorCriteriaIcon,
  SuccessCriteriaIcon,
  WarningCriteriaIcon
} from '@/components/boxes/box-containers/boxContainers.ts';

export const CriteriaTableCell = ({
  criteriaStatus,
  index
}: {
  criteriaStatus: 'success' | 'warning' | 'error' | undefined;
  index: number;
}): JSX.Element => {
  return (
    <StyledTableCell
      align="center"
      key={'criteria' + index}
      className="limited-width cell-height"
      component="td"
      scope="row"
    >
      {criteriaStatus !== undefined && (
        <>
          {criteriaStatus === 'success' ? (
            <SuccessCriteriaIcon color={'success'} fontSize={'small'} className={'criteria'} />
          ) : criteriaStatus === 'warning' ? (
            <WarningCriteriaIcon color={'warning'} fontSize={'small'} className={'criteria'} />
          ) : (
            <ErrorCriteriaIcon color={'error'} fontSize={'small'} className={'criteria'} />
          )}
        </>
      )}
    </StyledTableCell>
  );
};
